import React, {useState, useEffect} from 'react'
import { Dropdown } from 'react-bootstrap';

import './pagination.styles.scss';

//icons
import RefreshPage from '../../assets/icons/Icons - Navigation Refresh.svg';
import NextPage from '../../assets/icons/Icon - Navigation - Next.svg';
import PrevPage from '../../assets/icons/Icon - Navigation - Previous.svg';
import DropdownArrow from '../../assets/icons/Icon - Arrow - Down.svg';


const Pagination = ({refresh, next, prev, rowChange, numEntries, query}) => { // setSearchQuery is to make sure we keep the searchQuery updated
    //const [pageNumber, setPageNumber] = useState(1); // which page of table the user is in. Start at page 1
    const [rowsOnPage, setRowsOnPage] = useState(10) // num rows shown in the box
    const [pageNumberRange, setPageNumberRange] = useState({ // page range displayed. Start at 1-10
        start: 1,
        end: 10
    });

    const [rowsForDropdown, setRowsForDropdown] = useState([10]); // rows for dropdown

    //DISABLE buttons
    const [disablePrev, setDisablePrev] = useState(false);
    const [disableNext, setDisableNext] = useState(false);
    const [disableRefresh, setDisableRefresh] = useState(false);
    const [disableRowchange, setDisableRowChange] = useState(false);


    useEffect(() => {

        if(numEntries === 0) { // if user has no tasks at all
            setPageNumberRange({start: 0, end: 0});
            setDisablePrev(true);
            setDisableNext(true);
            //setDisableRefresh(true);
            setDisableRowChange(true);
            return;
        }

        if(query.pageNumber  === 1) {  // if user on first page, then disable prev button o/w enable
            setDisablePrev(true);
            setDisableNext(false);
        } else{
            setDisablePrev(false); 
        }
        findPageNumbers();
        setRowsDropdown();
        setRowsOnPage(query.pageSize > 1000 ? 'All' : query.pageSize);

    }, [query.pageNumber, rowsOnPage, numEntries, query.pageSize]) // runs these functions if any of these variables changes.

    const setRowsDropdown = () => {
        
        const rowMap = [10, 25, 50, 100, 200];
        let rows = []; 

        if (numEntries < 10) {
            setRowsForDropdown([10]);
            return;
        }


        else{
            rowMap.forEach(row => {
                if(numEntries >= row) return rows.push(row);
            });

            if(rows[rows.length-1] !== numEntries) rows.push('All'); // if numEntries exactly equal to last number of rowDropdown, then dont put showAll in dropdown.

            setRowsForDropdown(rows);
        }
    }

    const findPageNumbers = () => {
        let rowsTemp = rowsOnPage === 'All'  ? numEntries : rowsOnPage;
        for(let i = 0; i < query.pageNumber; i++) {
            if(numEntries < rowsTemp) {
                setPageNumberRange({
                    start: 1,
                    end: numEntries
                });
                setDisableNext(true)
            }
            else {
                let end = (rowsTemp*(i + 1)) > numEntries ? numEntries : (rowsTemp*(i + 1));
                setPageNumberRange({ 
                    start:  (i*rowsTemp) + 1,
                    end: end
                });
               (numEntries <= end) && setDisableNext(true); 
            }  
        }
    }   

    const clickNextPage = () => {
        next();
    } 

    const clickPrevPage = () => {
        prev();
    } 

    const clickRefresh = () => {
        refresh();
    }

    const clickRowNum = (row) => {

        row === 'All' ?  rowChange(100000) : rowChange(row); // running the redux function.
    }

    return (
        <div className='pagination-container-main'>
            <button className='pagination-button-main' type='button' disabled={disableRefresh} onClick={() => clickRefresh()}>
                <img src={RefreshPage} alt='icon-refresh'/> 
            </button>

            <div className='pagination-row-selection-container'>
               
                <div className='pagination-text'>Show Rows:</div>
                <div>
                    <Dropdown >
                        <Dropdown.Toggle className='pagination-dropdown-toggle' as='div' disabled={disableRowchange}>
                            <span className='pagination-dropdown-toggle-text' >{rowsOnPage}</span>
                            <img alt='dropdown-arrow' src={DropdownArrow}/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='pagination-dropdown-container'>
                            {    
                                rowsForDropdown.map((row, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <Dropdown.Item className='pagination-dropdown-row' key={row} onClick={() => clickRowNum(row)}>{row}</Dropdown.Item>
                                            {index < rowsForDropdown.length - 1 && <Dropdown.Divider />}
                                        </React.Fragment>
                                    )
                                })
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
               
                <div className='pagination-buttons-and-text-container'>
                    <div className='pagination-text' >
                        {`${pageNumberRange.start} - ${pageNumberRange.end} of ${numEntries ? numEntries : 0} entries`}
                    </div>       
                    <div className='pagination-button-group'>
                        <button className='pagination-button' type='button' onClick={() => clickPrevPage()} disabled={disablePrev}>
                            <img src={PrevPage} alt='icon-prev'/> 
                        </button>
                        <button className='pagination-button' type='button' onClick={() => clickNextPage()} disabled={disableNext}>
                            <img src={NextPage} alt='icon-next'/> 
                        </button>
                    </div>
                </div>
        </div>
    )
}

export default Pagination;
